import React from 'react'
import { Modal, message } from 'antd'
import { Dialog as DialogMobile, Toast } from 'antd-mobile'
import { ExclamationCircleFill, InformationCircleOutline, CheckCircleOutline } from 'antd-mobile-icons'
import store from '@/redux'
import { formatMessage, isMobileFun } from '@/utils/common'
let commonStore = {}
store.subscribe(() => {
  const state = store.getState()
  commonStore = state.commonStore
})

export const modalErrorRefreshCode = ({ title, content }, cb) => {
  if (isMobileFun()) {
    // 移动端
    return DialogMobile.alert({
      header: (
        <div className="displayFlex alignCenter">
          <ExclamationCircleFill
            style={{
              fontSize: 32,
              color: 'var(--adm-color-warning)'
            }}
          />
          <span className="ml10 tagTypeVal fs-15">
            {title || formatMessage(commonStore, 'languageObj.commonLocale.errorTitle')}
          </span>
        </div>
      ),
      // title: title || formatMessage(commonStore, 'languageObj.commonLocale.errorTitle'),
      // dangerouslySetInnerHTML千万不要换的
      content: <>{<div className="word_break_all" dangerouslySetInnerHTML={{ __html: content }}></div>}</>,
      onConfirm: () => {
        cb && cb()
      }
    })
  }

  return Modal.error({
    width: 500,
    centered: true,
    className: 'modal_wrapper nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: title || formatMessage(commonStore, 'languageObj.commonLocale.errorTitle'),
    autoFocusButton: null,
    // dangerouslySetInnerHTML千万不要换的
    content: <>{<div className="word_break_all" dangerouslySetInnerHTML={{ __html: content }}></div>}</>,
    onOk: () => {
      cb && cb()
    }
  })
}

export const modalError = ({ title, content }, cb) => {
  if (isMobileFun()) {
    // 移动端
    return DialogMobile.alert({
      header: (
        <div className="displayFlex alignCenter">
          <ExclamationCircleFill
            style={{
              fontSize: 32,
              color: 'var(--adm-color-warning)'
            }}
          />
          <span className="ml10 tagTypeVal fs-15">
            {title || formatMessage(commonStore, 'languageObj.commonLocale.errorTitle')}
          </span>
        </div>
      ),
      // title: title || formatMessage(commonStore, 'languageObj.commonLocale.errorTitle'),
      content: <div className="word_break_all">{content}</div>,
      onConfirm: () => {
        cb && cb()
      }
    })
  }

  return Modal.error({
    width: 500,
    centered: true,
    className: 'modal_wrapper nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: title || formatMessage(commonStore, 'languageObj.commonLocale.errorTitle'),
    autoFocusButton: null,
    content: <div className="word_break_all">{content}</div>,
    onOk: () => {
      cb && cb()
    }
  })
}
export const modalInfo = ({ title, content, width }, cb) => {
  if (isMobileFun()) {
    // 移动端
    return DialogMobile.alert({
      header: (
        <div className="displayFlex alignCenter">
          <InformationCircleOutline
            style={{
              fontSize: 32
            }}
          />
          <span className="ml10 tagTypeVal fs-15">
            {title || formatMessage(commonStore, 'languageObj.commonLocale.infoTitle')}
          </span>
        </div>
      ),
      // title: title || formatMessage(commonStore, 'languageObj.commonLocale.infoTitle'),
      content: <div className="word_break_all">{content}</div>,
      onConfirm: () => {
        cb && cb()
      }
    })
  }

  return Modal.info({
    width: width || 500,
    centered: true,
    className: 'modal_wrapper nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: title || formatMessage(commonStore, 'languageObj.commonLocale.infoTitle'),
    autoFocusButton: null,
    content: <div className="word_break_all">{content}</div>,
    onOk: () => {
      cb && cb()
    }
  })
}
export const modalSuccess = ({ title, content }, cb) => {
  if (isMobileFun()) {
    // 移动端
    return DialogMobile.alert({
      header: (
        <div className="displayFlex alignCenter">
          <CheckCircleOutline
            style={{
              fontSize: 32,
              color: 'var(--adm-color-success)'
            }}
          />
          <span className="ml10 tagTypeVal fs-15">
            {title || formatMessage(commonStore, 'languageObj.commonLocale.successTitle')}
          </span>
        </div>
      ),
      // title: title || formatMessage(commonStore, 'languageObj.commonLocale.successTitle'),
      content: <div className="word_break_all">{content}</div>,
      onConfirm: () => {
        cb && cb()
      }
    })
  }

  return Modal.success({
    width: 500,
    centered: true,
    className: 'modal_wrapper nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: title || formatMessage(commonStore, 'languageObj.commonLocale.successTitle'),
    autoFocusButton: null,
    content: <div className="word_break_all">{content}</div>,
    onOk: () => {
      cb && cb()
    }
  })
}
export const modalWarning = ({ title, content }, cb) => {
  if (isMobileFun()) {
    // 移动端
    return DialogMobile.alert({
      header: (
        <div className="displayFlex alignCenter">
          <ExclamationCircleFill
            style={{
              fontSize: 32,
              color: 'var(--adm-color-warning)'
            }}
          />
          <span className="ml10 tagTypeVal fs-15">
            {title || formatMessage(commonStore, 'languageObj.commonLocale.warningTitle')}
          </span>
        </div>
      ),
      // title: title || formatMessage(commonStore, 'languageObj.commonLocale.warningTitle'),
      content: <div className="word_break_all">{content}</div>,
      onConfirm: () => {
        cb && cb()
      }
    })
  }
  return Modal.warning({
    width: 500,
    centered: true,
    className: 'modal_wrapper nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: title || formatMessage(commonStore, 'languageObj.commonLocale.warningTitle'),
    autoFocusButton: null,
    content: <div className="word_break_all">{content}</div>,
    onOk: () => {
      cb && cb()
    }
  })
}
export const modalConfirm = ({ content, title, cancelText, okText, onCancel }, cb) => {
  if (isMobileFun()) {
    // 移动端
    let obj = {}
    if (okText) {
      obj.confirmText = okText
    }
    return DialogMobile.confirm({
      header: (
        <div className="displayFlex alignCenter">
          <ExclamationCircleFill
            style={{
              fontSize: 32,
              color: 'var(--adm-color-warning)'
            }}
          />
          <span className="ml10 tagTypeVal fs-15">
            {title || formatMessage(commonStore, 'languageObj.commonLocale.confirmTitle')}
          </span>
        </div>
      ),
      ...obj,
      cancelText,
      onCancel,
      // title: title || formatMessage(commonStore, 'languageObj.commonLocale.confirmTitle'),
      content: <div className="word_break_all">{content}</div>,
      onConfirm: () => {
        cb && cb()
      }
    })
  }
  Modal.confirm({
    width: 500,
    centered: true,
    cancelText,
    okText,
    onCancel,
    className: 'modal_wrapper nike_confirm nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: title || formatMessage(commonStore, 'languageObj.commonLocale.confirmTitle'),
    autoFocusButton: null,
    content: <div className="word_break_all">{content}</div>,
    onOk: () => {
      cb && cb()
    }
  })
}

export const messageModal = (type, { content }) => {
  if (isMobileFun()) {
    // 移动端
    let typeIcon = type
    if (type === 'error') {
      typeIcon = 'fail'
    }
    Toast.show({
      icon: typeIcon,
      content: content
    })
    return
  }
  message[type]({
    className: 'nike_message nike_zoom',
    // getContainer: document.getElementById('main-container'),
    content: <>{content}</>
  })
}
export const destroyModal = m => {
  try {
    m.destroy()
  } catch (error) {}
  try {
    DialogMobile.clear()
  } catch (error) {}
}
